import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center gap-2" }

import { hasPermission } from '@/composables/RequiredPermissions'
import { PERMISSIONS } from '@/models/enums/permissions'
import { ILicenseSituation, LICENSE_WARNING_PERCENT } from '@/models/license'
import * as licenseService from '@/services/licenseService'
import { useLanguageStore } from '@/stores/LanguageStore'
import Message from 'primevue/message'
import { computed, onMounted, ref } from 'vue'
import { RouterLink, useRoute } from 'vue-router'

/**
 * Aviso de licença para administradores, em todas as páginas: limite próximo, atingido ou
 * excedido. Consulta uma vez por sessão; fechar vale até o próximo login.
 */
const DISMISS_KEY = 'licenseAlertDismissed'

export default /*@__PURE__*/_defineComponent({
  __name: 'LicenseAlert',
  setup(__props) {

const languageStore = useLanguageStore()
const route = useRoute()
const t = (key: string, params?: Record<string, unknown>) =>
  languageStore.t(`views.license.alert.${key}`, params ?? {})

const situation = ref<ILicenseSituation | null>(null)
const dismissed = ref(sessionStorage.getItem(DISMISS_KEY) === 'true')

const alert = computed(() => {
  const s = situation.value
  // A propria tela de licenca ja mostra a situacao com detalhe.
  if (!s || dismissed.value || route.name === 'ManagementLicense') return null
  // Cliente sem contrato por pontos: nada a avisar.
  if (!s.ativa) return null
  if (s.excedida)
    return { severity: 'error', text: t('exceeded', { used: s.usados, total: s.totalPontos }) }
  if (s.limiteAtingido)
    return { severity: 'error', text: t('limitReached', { total: s.totalPontos }) }
  if (s.percentualUso >= LICENSE_WARNING_PERCENT)
    return { severity: 'warn', text: t('nearLimit', { percent: s.percentualUso }) }
  return null
})

const dismiss = () => {
  dismissed.value = true
  sessionStorage.setItem(DISMISS_KEY, 'true')
}

onMounted(() => {
  if (dismissed.value || !hasPermission(PERMISSIONS.MANAGE.LICENSE_MANAGE)) return
  licenseService
    .getSituation()
    .then((res) => (situation.value = res.data))
    .catch(() => (situation.value = null))
})

return (_ctx: any,_cache: any) => {
  return (alert.value)
    ? (_openBlock(), _createBlock(_unref(Message), {
        key: 0,
        severity: alert.value.severity,
        closable: "",
        onClose: dismiss
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(alert.value.text), 1),
            _createVNode(_unref(RouterLink), {
              to: { name: 'ManagementLicense' },
              class: "font-semibold underline"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(t('seeLicense')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["severity"]))
    : _createCommentVNode("", true)
}
}

})